// extracted by mini-css-extract-plugin
export var actionButton = "_pn-0";
export var actionMenuContainer = "_pn-i";
export var bubble = "_pn-2";
export var bubbleActionMenu = "_pn-j";
export var bubbleContext = "_pn-6";
export var bubbleItems = "_pn-7";
export var customer = "_pn-3";
export var divider = "_pn-8";
export var fileList = "_pn-9";
export var hiddenComment = "_pn-o";
export var infoAbove = "_pn-a";
export var internal = "_pn-4";
export var lightActionButton = "_pn-1";
export var link = "_pn-b";
export var merchant = "_pn-5";
export var message = "_pn-c";
export var profilePicture = "_pn-e";
export var quillToolbarContainer = "_pn-f";
export var senderDate = "_pn-g";
export var senderDateCustomer = "_pn-h";
export var senderName = "_pn-d";
export var time = "_pn-k";
export var uploadedImage = "_pn-l";
export var username = "_pn-m";
export var xsmall = "_pn-n";